import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux"; // Import Provider
import { store, persistor } from "./Redux/store"; // Import the Redux store and persistor
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import TagManager from "react-gtm-module"; // Import GTM module

// Initialize GTM
const tagManagerArgs = {
  gtmId: "GTM-WKCL4JTV", // Replace with your actual GTM ID
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Measuring app performance
reportWebVitals();
